module.exports = __webpack_public_path__ + "img/nueva-ertiga-booster-green.e547abb1.svg";